exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-type {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 12px;\n  text-transform: none;\n  font-weight: 400; }\n  .content-type__icon img {\n    margin-right: 8px;\n    width: 16px;\n    height: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/content_type/index.scss
// module id = 2138
// module chunks = 69